import { type Specs } from '@doxyme/extensions-bridge';
import { useEffect, useState } from 'react';

type Applet = Specs.Applet.Applet;

export type UseIsAppletLoadedReturnType = {
  isLoaded: boolean;
};

export function useIsAppletLoaded(
  applet?: Applet,
): UseIsAppletLoadedReturnType {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (applet) {
      applet.frame.addEventListener('load', () => {
        setIsLoaded(true);
      });
    } else {
      setIsLoaded(false);
    }
  }, [applet]);

  return {
    isLoaded,
  };
}
